import APIRequest from "./APIRequest";

export const getSettingsWithLogs = (params) => {
  return APIRequest.get(`admin/settings`, params);
};

export const uploadBrandLogo = (file) => {
  const formData = new FormData();
  formData.append('brandLogo', file);
  return APIRequest.post(`admin/settings`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};


